<template>
  <div class="animated fadeIn">
      <b-card>
          <div slot="header">My Pending Approval/Task 
            <div class="card-header-actions">
                <b-row>
                  <span class="pt-1 pr-2">Filter</span>
                  <input type="search" style="width:200px; height:34px !important; margin-right:2px;" v-model="filter" placeholder="Type to Search"/>
                  <b-pagination v-show="(todos.items.length>0)"
                    align="right" style="margin-bottom: -25px !important;"
                    :total-rows="todos.total"
                    :per-page="todos.limit"
                    v-model="todos.page"
                  ></b-pagination>
                </b-row>
            </div>
          </div>

        <div v-show="(todos.items.length>0)" style="margin-top:-21px;">
          <b-table
              class="m-0"
              ref="tblTaskTodo"
              responsive striped hover small
              :items="todos.items"
              :fields="todoFields"
              :current-page="todos.page"
              :per-page="todos.limit"
              :sort-by.sync="todos.sortBy"
              :sort-desc.sync="todos.sortDesc"
              @row-clicked="selectItem"
              :filter="filter"
              @filtered="onFiltered"
              show-empty
            >
          <template v-slot:cell(creatorName)="data">
            {{ data.item.creatorNik}} | {{data.item.creatorName}}
          </template>
          <template v-slot:cell(createdon)="data">
            {{ data.item.createdon | moment("ddd DD-MMM-YYYY hh:mm") }}
          </template>
          <template v-slot:cell(empty)="scope">
            <h4>{{ scope.emptyText }}</h4>
          </template>
          </b-table>
        </div>
      </b-card>

      <b-card>
          <div slot="header">My Team's Pending Approval/Task 
            <div class="card-header-actions">
                <b-pagination v-show="(teamtodos.total>0)"
                  align="right" style="margin-bottom: -25px !important;"
                  :total-rows="teamtodos.total"
                  :per-page="teamtodos.limit"
                  v-model="teamtodos.page"
                ></b-pagination>
            </div>
          </div>

        <div v-show="(teamtodos.total>0)" style="margin-top:-21px;">
          <b-table
              class="m-0"
              ref="tblTeamTodo"
              responsive striped hover small
              :items="TeamTodo"
              :fields="teamtodoFields"
              :current-page="teamtodos.page"
              :per-page="teamtodos.limit"
              :sort-by.sync="teamtodos.sortBy"
              :sort-desc.sync="teamtodos.sortDesc"
              @row-clicked="selectItem"
            >
          <template v-slot:cell(creatorName)="data">
            {{ data.item.creatorNik}} | {{data.item.creatorName}}
          </template>
          <template v-slot:cell(createdon)="data">
            {{ data.item.createdon | moment("ddd DD-MMM-YYYY hh:mm") }}
          </template>
          </b-table>
        </div>
      </b-card>
  </div>
</template>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import moment from "moment";
import task from "../apis/task";
import toastr from "mini-toastr";
toastr.init();

export default {
  components: {Loading},
  data() {
    return {
      showFilter: false,
      horizontal: true,
      isLoading:false,
      showReport:false,
      reportUrl: null,
      model:{},
      todos:{
        items:[],
        page: 1,
        limit: 20,
        total: 0,
        sortBy: 'createdon',
        sortDesc: false,
        sortDir:'asc'
      },
      todoFields: [
          {
            key: "wftypekey",
            label: "Task/Approval Name",
            sortable: true
          },
          {
            key: "taskname",
            label: "Task/Approval Description",
          },
          {
            key: "createdby",
            label: "Created By",
            sortable: true
          },
          {
            key: "createdon",
            label: "Created @",
            sortable: true
          },
      ],      
      teamtodos:{
        items:[],
        page: 1,
        limit: 20,
        total: 0,
        sortBy: 'createdon',
        sortDesc: false,
        sortDir:'asc'
      },
      teamtodoFields: [
          {
            key: "crewname",
            label: "Team Name",
            sortable: true
          },
          {
            key: "wftypekey",
            label: "Task/Approval Name",
            sortable: true
          },
          {
            key: "taskname",
            label: "Task/Approval Description",
          },
          {
            key: "createdby",
            label: "Created By",
            sortable: true
          },
          {
            key: "createdon",
            label: "Created @",
            sortable: true
          },
      ],
      filter: ''      
    };
  },
  watch: {
    filter: function(newVal, oldVal) {
      if (oldVal !== undefined && newVal !== oldVal) {
        this.todos.page = 1;
      }
      this.saveFilter();
    },
    "todos.page": function() {
      this.saveFilter();
    },
    "todos.sortBy": function() {
      this.saveFilter();
    },
    "todos.sortDesc": function() {
      this.saveFilter();
    },
  },
  created: async function() {
    this.restoreFilter();
    await this.TaskTodo();
  },
  beforeRouteLeave(to, from, next) {
    this.saveFilter();
    next();
  },
  sockets: {
    task_changed: function (data) {
      if (data.compcode === this.$store.state.user.compcode) {
        this.TaskTodo();
        this.refreshTeam();
      }
    },
  },
  methods: {
    onFiltered(filteredItems) {
      this.todos.total = filteredItems.length;
      const maxPage = Math.ceil(this.todos.total / this.todos.limit) || 1;
      if (this.todos.page > maxPage) {
        this.todos.page = 1;
      }
    },
    TaskTodo: async function() {
      this.todos.sortDir = this.todos.sortDesc ? "desc" : "asc";
      const list = await task.mypending(this.todos);
      this.todos.items = list || [];
      this.todos.total = (list || []).length;
      const maxPage = Math.ceil(this.todos.total / this.todos.limit) || 1;
      if (this.todos.page > maxPage) {
        this.todos.page = 1;
      }
      return list;
    },    
    TeamTodo: async function() {
      this.teamtodos.sortDir = this.todos.sortDesc ? "desc" : "asc";
      const list = await task.teampending(this.teamtodos);
      return list;
    },    
    saveFilter() {
      const approvalFilter = {
        filter: this.filter,
        page: this.todos.page,
        limit: this.todos.limit,
        sortBy: this.todos.sortBy,
        sortDesc: this.todos.sortDesc,
      };
      const filter = this.$store.state.filter || {};
      filter.approval = approvalFilter;
      this.$store.commit("filter", filter);
    },
    restoreFilter() {
      const filter = this.$store.state.filter;
      if (filter && filter.approval) {
        if (filter.approval.filter !== undefined) {
          this.filter = filter.approval.filter;
        }
        if (filter.approval.page) {
          this.todos.page = filter.approval.page;
        }
        if (filter.approval.limit) {
          this.todos.limit = filter.approval.limit;
        }
        if (filter.approval.sortBy) {
          this.todos.sortBy = filter.approval.sortBy;
        }
        if (filter.approval.sortDesc !== undefined) {
          this.todos.sortDesc = filter.approval.sortDesc;
        }
      }
    },
    async refreshMy(ctx) {
      await this.TaskTodo();
      if (this.$refs.tblTaskTodo) {
        this.$refs.tblTaskTodo.refresh();
      }
    },
    async refreshTeam(ctx) {
      if (this.$refs.tblTeamTodo) {
        this.$refs.tblTeamTodo.refresh();
      }
    },
    selectItem(item,index) {
      this.saveFilter();
      this.$router.push({name :'app.approvalfrm', params: { taskkey: item.taskkey, key: item.taskassignkey}});
    },    
    close(){
      this.saveFilter();
      this.$router.push({name:"app.modules"});
    },       
  }
};
</script>
